/*  React  */
import React from 'react';

export const HMS = (props) => {
    const { includeDays, includeText, noHours, noSeconds, seconds, sx } = props;

    let totalSeconds = 0;

    if (typeof seconds !== 'undefined') {
        totalSeconds = seconds;
    }

    let days = null;
    let hours = Math.floor(totalSeconds / 3600);
    if (typeof includeDays && includeDays) {
        days = Math.round(hours / 24);
        hours %= 24;
    }
    totalSeconds %= 3600;
    const minutes = Math.floor(totalSeconds / 60);
    totalSeconds = Math.round(totalSeconds % 60);

    if (!seconds) {
        return <span style={sx}>-</span>;
    }

    return (
        <span style={sx}>
            {typeof includeDays && includeDays && (
                <>
                    {days}{' '}
                    {includeText && (
                        <>
                            day
                            {days !== 1 && 's'}
                            {', '}
                        </>
                    )}
                </>
            )}
            {!noHours &&
                hours.toString().padStart(2, '0') + (!includeText ? ':' : '')}
            {includeText && ` hour${hours !== 1 ? 's' : ''}, `}
            {minutes.toString().padStart(2, '0')}
            {includeText && ` minute${minutes !== 1 ? 's' : ''}, `}
            {!noSeconds && (
                <>
                    {!includeText ? ':' : ''}
                    {totalSeconds.toString().padStart(2, '0')}
                    {includeText && ` second${seconds !== 1 ? 's' : ''} `}
                </>
            )}
        </span>
    );
};
